<script>
import axios from 'axios'
import { saveAs } from 'file-saver'
import { Base64 } from 'js-base64'

export default {
  name: 'DictionaryExport',
  props: {
    entity: {
      type: String,
      default: null,
    },
    all: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    isDisabled() {
      if (this.all) return false
      if (this.items && this.items.length) return false
      return true
    },
  },
  methods: {
    submit() {
      this.loading = true
      const data = {
        type: this.all ? 'ALL' : 'IDS',
        ids: this.items
          ? this.items.map(el => (el.id ? el.id : el.code))
          : null,
      }
      axios
        .post(`/api/1/${this.entity}/export`, data)
        .then(({ data }) => {
          this.download(data.data)
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    download(base64) {
      const file = new File(
        [Base64.decode(base64)],
        `export_${this.entity}.json`,
        { type: 'text/plain;charset=utf-8' }
      )
      saveAs(file)
    },
  },
}
</script>

<template>
  <v-btn
    :disabled="isDisabled"
    :loading="loading"
    color="primary"
    @click="submit()"
  >
    {{ $t(`buttons__${all ? 'export_all' : 'export'}`) }}
  </v-btn>
</template>
